export default "__VITE_ASSET__b0ec042e__"